import { render } from "./FeatureUnavailable.vue?vue&type=template&id=748ca1f2"
import script from "./FeatureUnavailable.vue?vue&type=script&lang=js"
export * from "./FeatureUnavailable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__